


































import { Component, Vue, Watch } from 'vue-property-decorator';
import Banner from '@/components/banner/Bannerwrap.vue';
import Toolbar from '@/components/toolbar/Toolbar.vue';
import Newsitem from './Newsitem.vue';
import KnowMoreBtn from '../../components/know-more-button/Know-more-btn.vue';
import { hasClass, addClass } from '@/util/domClass.ts';

import axios from 'axios';
import {
  getExhibitionUrl,
  getTestingUrl,
  getMaterialUrl,
} from '@/util/lang.ts';

import imgs from '@/util/imgs.ts';

@Component({
  components: {
    Banner,
    Toolbar,
    Newsitem,
    KnowMoreBtn,
  },
})
export default class Newslist extends Vue {
  // initial data
  private imgs = imgs;
  private iszoom: boolean = false;

  private len: number = 5;

  private newsarr: object[] = [
    // {
    //   ID: '01',
    //   SHOWTIME: '2018/11/08 00:00:00',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交加广交会现场宁波登越新材料科技有限公司参',
    // },
    // {
    //   ID: '02',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
    // {
    //   ID: '03',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
    // {
    //   ID: '04',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
    // {
    //   ID: '05',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
    // {
    //   ID: '06',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
    // {
    //   ID: '07',
    //   SHOWTIME: '2018/11/08',
    //   TITLE: '宁波登越新材料科技有限公司参加广交会现场',
    //   JJ: '宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交宁波登越新材料科技有限公司参加广交会现场宁波登越新材料科技有限公司参加广交',
    // },
  ];

  // computed
  get filterarr() {
    const arr = Object.assign([], this.newsarr);
    let len = this.len;
    if (this.newsarr.length < this.len) {
      len = this.newsarr.length;
    }

    arr.length = len;
    return arr;
  }

  @Watch('$route')
  private onRouteChanged(to: any) {
    this.fetchUI(to.query);
  }

  @Watch('$store.state.lang')
  private onLangChanged() {
    this.fetchData();
  }

  // lifecycle hook
  private mounted() {
    this.$store.dispatch('setToolbarItems', [
      {
        name: '展会信息',
        active: '1',
        href: '/#/newslist?section=1',
      },
      {
        name: '报告',
        active: '2',
        href: '/#/newslist?section=2',
      },
      {
        name: '相关资料',
        active: '3',
        href: '/#/newslist?section=3',
      },
    ]);

    this.$nextTick(() => {
      this.fetchUI(this.$route.query);
      this.iszoom = true;
    });
  }

  private fetchUI(query: any) {
    let section = '1';
    let noscroll = false;

    if (query) {
      // window.console.log('query.noscroll:', query.noscroll);
      noscroll = query.noscroll || false;
      section = query.section || '1';
    }

    if (!noscroll) {
      let offsetTop = 0;

      if (!!query.section) {
        const anchor: any = this.$refs.anchor;
        // console.log(anchor)
        offsetTop = anchor.offsetTop - 100 || 0;
      }

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }

    this.$store.dispatch('setToolbarActive', section);

    this.fetchData();
  }

  private handleScrolltop(el: any) {
    const { top } = el.getBoundingClientRect();

    if (top < 100) {
      this.$store.dispatch('setShowbar', true);
    } else {
      this.$store.dispatch('setShowbar', false);
    }
  }

  private fetchData() {
    if (this.$store.state.toolbarActive === '2') {
      // 检测报告
      const testingUrl = getTestingUrl(this.$store.state.lang);
      axios.get(testingUrl).then((res: any) => {
        // window.console.log(res.data);
        // return []
        // data item 字段
        // PICURL 2018112622371614.jpg
        // http://dentik.sansg.com/upload/2018112622371614.jpg

        this.newsarr = res.data;
        this.len = 5;

        this.triggerNewsAnimation();
      });
    } else if (this.$store.state.toolbarActive === '3') {
      // 相关资料
      const materialUrl = getMaterialUrl(this.$store.state.lang);
      axios.get(materialUrl).then((res: any) => {
        // window.console.log(res.data);
        // return []
        // data item 字段
        // PICURL 2018112622371614.jpg

        this.newsarr = res.data;
        this.len = 5;

        this.triggerNewsAnimation();
      });
    } else {
      // 展会信息
      const exhibitionUrl = getExhibitionUrl(this.$store.state.lang);
      axios.get(exhibitionUrl).then((res: any) => {
        // window.console.log(res.data);
        // return []
        // data 字段
        // JJ TITLE SHOWTIME

        this.newsarr = res.data;
        this.len = 5;

        this.triggerNewsAnimation();
      });
    }
    if (this.$store.state.lang === 'en') {
      this.$store.dispatch('setToolbarItems', [
      {
        name: 'Exhibition',
        active: '1',
        href: '/#/newslist?section=1',
      },
      {
        name: 'Test Report',
        active: '2',
        href: '/#/newslist?section=2',
      },
      {
        name: 'Related articles',
        active: '3',
        href: '/#/newslist?section=3',
      },
    ]);
    } else {
      this.$store.dispatch('setToolbarItems', [
      {
        name: '展会信息',
        active: '1',
        href: '/#/newslist?section=1',
      },
      {
        name: '报告',
        active: '2',
        href: '/#/newslist?section=2',
      },
      {
        name: '相关资料',
        active: '3',
        href: '/#/newslist?section=3',
      },
    ]);
    }
  }

  private showMore() {
    // window.console.log(this.len);
    this.len += 5;
    // window.console.log(this.len);
  }

  /**
   * 触发新闻列表的动画
   */
  private triggerNewsAnimation() {
    const $newsBox: any = this.$refs['news-box'];
    // console.log('$newsBox = ', $newsBox);
    if ($newsBox) {
      // $newsBox.classList.toggle('news-list-anmi-out');
      $newsBox.className = '';
      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          $newsBox.className = 'news-list-anmi-out-in';
        });
      });
    }
  }
}
